import { useNavigate } from "react-router-dom";
import { dentalIcons } from "../../dentail-indetifcation/utils-icons/dentalIcons";

import { TimerResetIcon as Reset, ArrowRight } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { Input } from "antd";
import CustomPrimaryButton from "../../dentail-indetifcation/components/d-reusable/CustomPrimaryButton";

export function Toolbar({
  selectedToolId,
  setSelectedToolId,
  onImageUpload,

  onReset,
  onImageTransform,
  onMoveImage,
  onToolChange,

  onToggleCommentPanel,
  deleteSelected,
  onCrop,
  wrapperRotation,
  onDirecltyRotate,
  handleAngleReset,
  onOpenClick,
  StylePanel,
  scale,
  onScaleChange,
  onUnitChange,
  syncScale,
  handleCropImage,
  comments,
  onHorizontalFlip,
}) {
  const [hoveredTool, setHoveredTool] = useState(null);
  const [scaleInput, setScaleInput] = useState("");

  // remember the last *applied* value (string form); null means "never applied"
  const lastAppliedRef = useRef(null);

  // keep input in sync with the saved/loaded scale
  useEffect(() => {
    if (Number.isFinite(scale) && scale > 0) {
      const s = String(scale);
      setScaleInput(s);
      // optional: also treat incoming as already applied:
      lastAppliedRef.current = s;
    } else {
      setScaleInput(""); // show empty if no valid saved scale
    }
  }, [scale]); // <- key: update when `scale` prop changes
  // normalize for comparison
  const norm = (s) => String(s ?? "").trim();

  // Button disabled logic:
  // - If never applied before (ref === null): enabled unless input is empty "".
  // - Otherwise: disabled only when input === last applied.
  const disableApply =
    lastAppliedRef.current === null
      ? norm(scaleInput) === "" // first time: allow applying non-empty
      : norm(scaleInput) === norm(lastAppliedRef.current);

  const handleScaleSubmit = () => {
    const raw = norm(scaleInput);
    // Treat empty/invalid as "no scale" → default to px
    const parsed = raw === "" ? NaN : Number.parseFloat(raw);

    if (!Number.isFinite(parsed) || parsed <= 0) {
      onScaleChange(0); // or keep previous value if you prefer
      onUnitChange("px");
      syncScale({ scale: 0, unit: "px" }); // ✅ correct fields

      lastAppliedRef.current = "";
      return;
    }

    onScaleChange(parsed);
    syncScale({ scale: parsed, unit: "mm" }); // ✅ correct fields in one transact
    onUnitChange("mm");
    lastAppliedRef.current = String(parsed);
  };
  const navigate = useNavigate();
  const hasUnresolved =
    Array.isArray(comments) && comments.some((c) => c?.isResolved === false);

  const handleToolClick = (toolId) => {
    setSelectedToolId(toolId);
    if (toolId === "delete") {
      deleteSelected();
      return;
    }
    if (toolId === "upload") {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = (e) => {
        const file = e.target.files?.[0];
        if (file) onImageUpload(file);
      };
      input.click();
    } else if (toolId === "reset") {
      onReset();
    } else if (toolId === "text") {
      onToolChange("text");
    } else if (toolId === "comment") {
      onToolChange("comment");
    } else if (toolId === "dot") {
      onToolChange("dot");
    } else if (toolId === "arrow") {
      onToolChange("arrow");
    } else if (toolId === "crop") {
      onCrop();
    } else if (toolId === "toggle-comments") {
      onToggleCommentPanel();
    } else if (toolId === "guideline-vertical") {
      onToolChange("guideline-vertical");
    } else if (toolId === "guideline-horizontal") {
      onToolChange("guideline-horizontal");
    } else if (toolId.startsWith("move-")) {
      onMoveImage(toolId.replace("move-", ""));
    } else if (
      toolId.includes("rotate") ||
      toolId === "increase" ||
      toolId === "decrease"
    ) {
      onImageTransform(toolId);
    } else if (toolId === "open") {
      onOpenClick();
    }
  };

  const ToolButton = ({ tool, disabled = false, title, icon }) => {
    const isActive = selectedToolId === tool.id;
    return (
      <div className="image_analysis_container relative w-full">
        <div
          variant="ghost"
          size="sm"
          disabled={disabled}
          className={`h-[40px] w-[96%] rounded-md ${"hover:bg-[#F9FAFB]"} bg-tramsparent flex items-center gap-2 px-1 text-[#525866] font-medium cursor-pointer`}
          onClick={() => {
            handleToolClick(tool.id);
          }}
          onMouseEnter={() => setHoveredTool(tool.id)}
          onMouseLeave={() => {
            setHoveredTool(null);
          }}
        >
          <img
            src={tool.id === "reset" ? dentalIcons.resetDelIcon : icon}
            alt="icon"
            className="w-4 h-4 flex-shrink-0"
          />

          <p
            className={`${
              tool.id == "reset" ? "text-[#20C3FF]" : "text-[#525866]"
            }`}
          >
            {title}
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="w-full  ps-[8px] bg-white border-r border-gray-200 flex flex-col items-center shadow-sm h-full overflow-scroll">
      <div className="flex w-full flex-col items-center py-3 space-y-1">
        <div
          onClick={() => navigate("/dental-analysis/projects")}
          className="image_analysis_container flex items-center gap-2 w-full cursor-pointer hover:text-[#20C3FF] mb-2"
        >
          <img src={dentalIcons.backProjects} alt="back" className="h-5 w-5" />
          <p className="text-lg font-semibold">All Projects</p>
        </div>
        {/* History Controls */}
        <div className="w-full mt-2 text-[#A2A2A2]">ACTIONS</div>

        <div className="flex w-full flex-col items-center space-y-1 mb-0">
          {/* <ToolButton
            tool={{ id: "upload", icon: Upload, label: "Upload New Image" }}
            title={"New Image"}
            icon={dentalIcons.uploadImageIcon}
          /> */}

          <div className="w-[97%] p-1 bg-[#F5F7FA] mt-1 rounded-[8px] -ms-2">
            <div className="border-0 p-1 shadow-none bg-[#F5F7FA]">
              <span className="text-[#000000] text-[14px] font-semibold">
                {" "}
                Scale (mm)
              </span>
              <div className="pb-1 mt-1">
                <div className="space-y-3">
                  <div className="flex gap-2">
                    <Input
                      id="scale"
                      value={scaleInput}
                      onChange={(e) => setScaleInput(e.target.value)}
                      placeholder="Scale"
                      className="flex-1 h-9 !rounded-[8px] text-[10px]"
                      suffix="mm"
                    />
                    <CustomPrimaryButton
                      title="Apply"
                      isRound={true}
                      onClick={handleScaleSubmit}
                      width={50}
                      isHeight={true}
                      isDisbale={disableApply}
                      fontSize={12}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="flex w-[97%] items-center gap-2 -ms-2 mt-3 mb-2">
            <div
              onClick={handleCropImage}
              className="flex flex-col w-full items-center justify-center cursor-pointer"
            >
              <div className="w-full h-[36px] p-2 bg-[#F5F7FA] rounded-[8px] flex  items-center justify-center">
                <img src={dentalIcons.cropIcon} />
              </div>
              <span className="text-[#525866] text-[10px] mt-1">CROP</span>
            </div>
            <div
              className="flex flex-col w-full items-center justify-center cursor-pointer"
              onClick={() => onHorizontalFlip()}
            >
              <div className="w-full h-[36px] p-2 bg-[#F5F7FA] rounded-[8px] flex  items-center justify-center">
                <img src={dentalIcons.flipIcon} />
              </div>
              <span className="text-[#525866] text-[10px] mt-1">FLIP</span>
            </div>
            <div className="relative w-full">
              {wrapperRotation !== 0 && (
                <div
                  onClick={handleAngleReset}
                  className="absolute bg-[#E6EAF0] border-2 border-[#FFFFFF] h-[30px] w-[30px] rounded-full -top-3 -right-1 flex items-center justify-center cursor-pointer"
                >
                  <img src={dentalIcons.resetCross} alt="reset" />
                </div>
              )}
              <div
                className="flex flex-col w-full items-center justify-center cursor-pointer"
                onClick={() => onDirecltyRotate(90)}
              >
                <div className="w-full h-[36px] p-2 bg-[#F5F7FA] rounded-[8px] flex  items-center justify-center">
                  <img src={dentalIcons.rotateRight} />
                </div>
                <span className="text-[#525866] text-[10px] mt-1">ROTATE</span>
              </div>
            </div>
          </div>

          <div className="w-full text-[#A2A2A2] h-[1px] bg-[#EDEDED] -ms-3 my-2" />
          <div className="w-full text-[#A2A2A2]">GUIDELINES</div>
          {/* Guidelines */}
          <div className="flex w-[100%] gap-2 items-center my-2 -ms-1">
            <div className="w-[66.66px] flex flex-col items-center">
              <div
                className="bg-[#F5F7FA] rounded-[8px] w-[100%] h-[35px] cursor-pointer flex items-center justify-center"
                onClick={() => handleToolClick("guideline-horizontal")}
              >
                <img src={dentalIcons.horizontalLine} />
              </div>
              <span className="text-[#525866] text-[10px] mt-1">
                HORIZONTAL
              </span>
            </div>
            <div className="w-[66.66px] flex flex-col items-center">
              <div
                onClick={() => handleToolClick("guideline-vertical")}
                className="bg-[#F5F7FA] rounded-[8px] w-[100%] h-[35px] cursor-pointer flex items-center justify-center"
              >
                <img src={dentalIcons.verticalLine} />
              </div>
              <span className="text-[#525866] text-[10px] mt-1">VERTICAL</span>
            </div>
            <div className="w-[66.66px] flex flex-col items-center me-1">
              <div
                onClick={() => handleToolClick("dot")}
                className="bg-[#F5F7FA] rounded-[8px] w-[100%] h-[35px] cursor-pointer flex items-center justify-center"
              >
                <img src={dentalIcons.dotIcon} />
              </div>
              <span className="text-[#525866] text-[10px] mt-1">POINT</span>
            </div>
          </div>

          <div className="w-full text-[#A2A2A2] h-[1px] bg-[#EDEDED] -ms-3 my-2" />
        </div>
        <div className="w-full text-[#A2A2A2]">TEXT TOOLS</div>

        <div className="flex w-[97%] items-center gap-2 -ms-2 mt-2 mb-2">
          <div
            onClick={() => handleToolClick("text")}
            className="flex flex-col w-full items-center justify-center cursor-pointer"
          >
            <div className="w-full h-[36px] p-2 bg-[#F5F7FA] rounded-[8px] flex  items-center justify-center">
              <img src={dentalIcons.textToolIcon} />
            </div>
            <span className="text-[#525866] text-[10px] mt-1">TEXT</span>
          </div>
          <div
            className="flex flex-col w-full items-center justify-center cursor-pointer"
            onClick={() => handleToolClick("comment")}
          >
            <div className="w-full h-[36px] p-2 bg-[#F5F7FA] rounded-[8px] flex  items-center justify-center">
              <div className="relative">
                {hasUnresolved && (
                  <div className="absolute z-[99] left-3 top-0 h-2 w-2 rounded-full bg-red-500" />
                )}
                <img src={dentalIcons.chatTool} />
              </div>
            </div>
            <span className="text-[#525866] text-[10px] mt-1">COMMENT</span>
          </div>
          <div
            onClick={() => handleToolClick("arrow")}
            className="flex flex-col w-full items-center justify-center cursor-pointer"
          >
            <div className="w-full h-[36px] p-2 bg-[#F5F7FA] rounded-[8px] flex  items-center justify-center">
              {/* <img src={dentalIcons.textToolIcon} /> */}
              <ArrowRight />
            </div>
            <span className="text-[#525866] text-[10px] mt-1">ARROW</span>
          </div>
        </div>
        <div className="w-full text-[#A2A2A2] h-[1px] bg-[#EDEDED] -ms-3 my-2" />

        {StylePanel}

        <ToolButton
          tool={{
            id: "reset",
            icon: Reset,
            label: "Clear All Measurements",
          }}
          title={"Reset All"}
          icon={dentalIcons.deleteAll}
        />
        <div className="w-full text-[#A2A2A2] h-[1px] bg-[#EDEDED] -ms-3 my-2" />
      </div>
    </div>
  );
}
